import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2 } from "lucide-react";
import { useAdminAuth } from "../AdminAuthContext";
import { formatApiError } from "../adminApi";

const FIELD = "w-full rounded-lg border border-[#E5E7EB] px-4 py-3 text-[#1F2937] focus:outline-none focus:border-[#1E88E5] focus:ring-2 focus:ring-[#1E88E5]/20 transition";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A2342] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-8">
          <ShieldCheck className="text-[#1E88E5]" size={28} />
          <span className="text-white font-heading font-bold tracking-wide">MERIDIAN VANGUARD ADMIN</span>
        </div>
        <div className="bg-white rounded-xl p-8 shadow-xl">
          <h1 className="font-heading text-2xl font-bold text-[#0A2342]">Sign in</h1>
          <p className="mt-1 text-sm text-[#4B5563]">Access the administration dashboard.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4" noValidate>
            <div>
              <label className="block text-sm font-semibold text-[#0A2342] mb-1.5">Email</label>
              <input data-testid="login-email" className={FIELD} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-[#0A2342] mb-1.5">Password</label>
              <input data-testid="login-password" className={FIELD} type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-red-700 bg-red-50 rounded-lg px-3 py-2">{error}</p>}
            <button data-testid="login-submit" type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 rounded-lg bg-[#0A2342] text-white py-3 font-semibold hover:bg-[#1E88E5] transition-colors disabled:opacity-60">
              {loading && <Loader2 size={18} className="animate-spin" />} Sign In
            </button>
          </form>
          <div className="mt-4 text-center">
            <Link to="/admin/forgot-password" data-testid="login-forgot-link" className="text-sm text-[#1E88E5] hover:underline">Forgot password?</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
